import { useEditorContext } from "../EditorContext";
import FormLabel from "../FormCommonField/FormLabel";
import { getBorderStyleObj } from "../FormText/FormBaseStyle";
import { getFontFamily, toRGBA } from "../parser/utils";

export default ({ data }) => {
  const {
    options,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
    labelFontColor,
    labelDefaultFont,
    labelFontSize,
    labelHorizonAlignment,
    optionsDefaultFont,
    optionsFontSize,
    optionsFontColor,
    optionsHorizonAlignment,
  } = data;

  const { state } = useEditorContext();
  const { formBorderWidth, formBorderStyle, formBorderColor, formTextColor } =
    state.root.data;
  const customLabelStyle = {
    color: toRGBA(labelFontColor || formTextColor),
    fontFamily: labelDefaultFont,
    fontSize: labelFontSize,
    justifyContent: labelHorizonAlignment || "start",
  };

  const borderStyleObj = getBorderStyleObj(state.root.data);
  const optionFontFamily = getFontFamily(
    optionsDefaultFont,
    state.root.data.defultFont
  );

  return (
    <div
      style={{
        paddingTop,
        paddingBottom,
        paddingRight,
        paddingLeft,
        textAlign: "left",
        borderColor: formBorderColor,
      }}
    >
      <FormLabel data={data} customLabelStyle={customLabelStyle} />
      <div style={borderStyleObj}>
        {options.map((item, index) => {
          return (
            <div
              key={index}
              style={{
                height: 35,
                padding: "0 8px",
                borderBottom:
                  options.length === index + 1
                    ? 0
                    : [
                        formBorderWidth + "px",
                        formBorderStyle,
                        toRGBA(formBorderColor),
                      ].join(" "),
                display: "flex",
                justifyContent: optionsHorizonAlignment,
                alignItems: "center",
                gap: 8,
              }}
            >
              <div
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: 2,
                  border: "1px solid #cccccc",
                }}
              ></div>
              <div
                style={{
                  color: toRGBA(optionsFontColor || formTextColor),
                  fontFamily: optionFontFamily,
                  fontSize: `${optionsFontSize}px`, // 应用字体大小
                }}
              >
                {item.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
